<template>
  <header class="header-global">
    <base-nav class="navbar-main" transparent type effect="light" expand>
      <router-link slot="brand" class="navbar-brand mr-lg-5" to="/login">
        <h3 class="display-5 text-white">
          <span>Long Weekend</span>
        </h3>
      </router-link>

      <div class="row" slot="content-header" slot-scope="{ closeMenu }">
        <div class="col-6 collapse-brand">
          <a href="">
            <!-- <img src="img/brand/blue.png" /> -->
            <h5 class="display-5">
              <span>Long Weekend</span>
            </h5>
          </a>
        </div>
        <div class="col-6 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>
      <ul class="navbar-nav align-items-lg-center ml-lg-auto">
        <li class="nav-item" v-if="hideThisNavLink">
          <router-link to="/landing" class="nav-link nav-link-icon">
            <i class="fa fa-home"></i>
            <span class="nav-link-inner--text d-lg-none"></span>
            Home
          </router-link>
        </li>
        <li class="nav-item" @click="logout()" v-if="hideThisNavLink">
          <router-link to="/login" class="nav-link nav-link-icon">
            <i class="fa fa-sign-out"></i>
            <span class="nav-link-inner--text d-lg-none"></span>
            Logout
          </router-link>
        </li>
      </ul>
    </base-nav>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";
import { signOut, getUser } from "@/utils/auth.js";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,
  },
  methods: {
    logout: function() {
      signOut();
    },
  },
  computed: {
    hideThisNavLink() {
      return (
        this.$route.name !== "login" &&
        this.$route.name !== "register" &&
        this.$route.name !== "signupconfirm" &&
        this.$route.name !== "register" &&
        this.$route.name !== "components"
      );
    },
  },
};
</script>
<style></style>
